import React from "react";
import { ChevronRight } from "lucide-react";

/**
 * CollapsedSection — reusable collapsible section for "Awaiting me", "This week",
 * "My team", etc. Click header to expand/collapse.
 *
 * Usage:
 *   <CollapsedSection title="Awaiting me" count={5} countActive defaultOpen={false}>
 *     {rows}
 *   </CollapsedSection>
 */
export default function CollapsedSection({
  title,
  count,
  countActive = false,
  defaultOpen = false,
  children,
  onToggle,
  id,
}) {
  const [open, setOpen] = React.useState(defaultOpen);
  const handle = () => {
    const next = !open;
    setOpen(next);
    if (onToggle) onToggle(next);
  };
  return (
    <div>
      <button
        onClick={handle}
        aria-expanded={open}
        aria-controls={id ? `${id}-content` : undefined}
        style={{
          background: "transparent",
          border: "none",
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "16px 4px",
          cursor: "pointer",
          color: "var(--t2)",
          fontFamily: "var(--font-sans)",
          borderTop: "1px solid var(--bdr)",
          marginTop: 12,
          textAlign: "left",
          transition: "color .15s",
        }}
        className="dm-collapsed-header"
      >
        <ChevronRight
          size={16}
          style={{
            color: "var(--t3)",
            transition: "transform .2s",
            transform: open ? "rotate(90deg)" : "none",
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: 17,
            fontWeight: 600,
            color: "var(--t1)",
            letterSpacing: "-0.01em",
          }}
        >
          {title}
        </span>
        {count != null && count !== "" && (
          <span
            style={{
              color: countActive ? "var(--a)" : "var(--t3)",
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            {count}
          </span>
        )}
        <span style={{ flex: 1 }} />
      </button>
      {open && (
        <div
          id={id ? `${id}-content` : undefined}
          style={{
            paddingTop: 4,
            paddingBottom: 8,
            animation: "fadeIn .25s ease-out",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
